import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f24738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "contentbox" }
const _hoisted_3 = {
  key: 0,
  class: "contentbox-row"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "所在区域:", -1))
const _hoisted_5 = { class: "row-cont" }
const _hoisted_6 = { class: "contentbox-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "巡检名称:", -1))
const _hoisted_8 = { class: "row-cont" }
const _hoisted_9 = { class: "contentbox-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "巡检员:", -1))
const _hoisted_11 = { class: "row-cont" }
const _hoisted_12 = { class: "contentbox-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "提交日期:", -1))
const _hoisted_14 = { class: "row-cont" }
const _hoisted_15 = {
  key: 1,
  class: "contentbox-row"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "隐患位置:", -1))
const _hoisted_17 = { class: "row-cont" }
const _hoisted_18 = {
  key: 2,
  class: "contentbox-row"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "隐患类型:", -1))
const _hoisted_20 = { class: "row-cont" }
const _hoisted_21 = { class: "contentbox-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "巡检结果:", -1))
const _hoisted_23 = {
  key: 3,
  class: "contentbox-row"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "责任人:", -1))
const _hoisted_25 = { class: "row-cont" }
const _hoisted_26 = {
  key: 4,
  class: "contentbox-row"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "责任完成日期:", -1))
const _hoisted_28 = { class: "row-cont" }
const _hoisted_29 = {
  key: 5,
  class: "contentbox-row"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "处理结果:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "备注:")
], -1))
const _hoisted_32 = { class: "contentbox-row" }
const _hoisted_33 = { class: "row-cont" }
const _hoisted_34 = {
  key: 6,
  class: "contentbox-row"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "附件:", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 7,
  class: "contentbox-row"
}
const _hoisted_38 = { class: "row-cont" }
const _hoisted_39 = ["src", "onClick"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "step-info" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" 整改时间：")
const _hoisted_43 = { style: {"color":"#1e2124"} }
const _hoisted_44 = { class: "step-cont step-block" }
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "整改情况：", -1))
const _hoisted_47 = { class: "comment" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "附件：")
], -1))
const _hoisted_49 = ["src"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改单：")
], -1))
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "step-info" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 审核日期：")
const _hoisted_54 = { style: {"color":"#1e2124"} }
const _hoisted_55 = { class: "step-cont step-block" }
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审核结论：", -1))
const _hoisted_58 = { class: "comment" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "附件：")
], -1))
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "整改单：")
], -1))
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "contentbox" }
const _hoisted_64 = { class: "contentbox-row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "处理结果:", -1))
const _hoisted_66 = { class: "row-cont" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "附件:")
], -1))
const _hoisted_68 = { class: "contentbox-row" }
const _hoisted_69 = { class: "row-cont" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "整改单:")
], -1))
const _hoisted_71 = { class: "contentbox-row" }
const _hoisted_72 = { class: "row-cont" }
const _hoisted_73 = { class: "btnbox" }
const _hoisted_74 = { class: "contentbox" }
const _hoisted_75 = { class: "contentbox-row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "处理结果:", -1))
const _hoisted_77 = { class: "row-cont" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "附件:")
], -1))
const _hoisted_79 = { class: "contentbox-row" }
const _hoisted_80 = { class: "row-cont" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contentbox-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row-title" }, "整改单:")
], -1))
const _hoisted_82 = { class: "contentbox-row" }
const _hoisted_83 = { class: "row-cont" }
const _hoisted_84 = { class: "btnbox" }
const _hoisted_85 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_86 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.infodata.areaName), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.infodata.title), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.infodata.createName), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.infodata.createDate), 1)
        ]),
        (_ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.infodata.dangerSourceName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.infodata.dangerTypeName), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", {
            class: "row-cont",
            style: _normalizeStyle({
            color:
              _ctx.infodata.result === 1
                ? '#19B064'
                : _ctx.infodata.result === 2
                ? '#C21616'
                : '#D0D9E0',
          })
          }, _toDisplayString(_ctx.infodata.result === 1
              ? "正常"
              : _ctx.infodata.result === 2
              ? "异常"
              : "漏检"), 5)
        ]),
        (_ctx.infodata.result != 1 && _ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.infodata.changePersonName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.infodata.result != 1 && _ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.infodata.updateDate), 1)
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.infodata.status && _ctx.infodata.result != 1 && _ctx.queryPloyLoad.status != 4
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", {
                class: "row-cont",
                style: _normalizeStyle({
            color:
              _ctx.infodata.status === 1
                ? '#D69340'
                : _ctx.infodata.status === 2
                ? '#D0D9E0'
                : '#19B064',
          })
              }, _toDisplayString(_ctx.infodata.status === 1
              ? "未处理"
              : _ctx.infodata.status === 2
              ? "已处理"
              : "已解决"), 5)
            ]))
          : _createCommentVNode("", true),
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.infodata.remark), 1)
        ]),
        (_ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
          : _createCommentVNode("", true),
        (_ctx.queryPloyLoad.status != 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.imgFileList, (item, index) => {
                  return (_openBlock(), _createElementBlock("img", {
                    class: "remark-pic",
                    src: item.url,
                    alt: "",
                    key: index,
                    onClick: ($event: any) => (_ctx.previewimgfun(item.url))
                  }, null, 8, _hoisted_39))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.infodata.dealList && _ctx.infodata.dealList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createVNode(_component_van_steps, {
              active: _ctx.active,
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infodata.dealList, (li, i) => {
                  return (_openBlock(), _createBlock(_component_van_step, { key: i }, {
                    default: _withCtx(() => [
                      (li.status == 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", null, [
                                _hoisted_42,
                                _createElementVNode("span", _hoisted_43, _toDisplayString(li.createDate), 1)
                              ]),
                              _createElementVNode("div", null, "整改人: " + _toDisplayString(li.createName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("img", {
                                class: "logo",
                                src: require('@/assets/zgwc.png')
                              }, null, 8, _hoisted_45),
                              _hoisted_46,
                              _createElementVNode("div", _hoisted_47, _toDisplayString(li.remark), 1),
                              _hoisted_48,
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    class: "remark-pic",
                                    src: item.url,
                                    key: index
                                  }, null, 8, _hoisted_49))
                                }), 128))
                              ]),
                              _hoisted_50,
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    class: "remark-pic",
                                    src: item.url,
                                    key: index
                                  }, null, 8, _hoisted_51))
                                }), 128))
                              ])
                            ])
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", null, [
                                _hoisted_53,
                                _createElementVNode("span", _hoisted_54, _toDisplayString(li.createDate), 1)
                              ]),
                              _createElementVNode("div", null, "审核人: " + _toDisplayString(li.createName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("img", {
                                class: "logo",
                                src: 
                  li.status == 3
                    ? require('@/assets/sptg.png')
                    : require('@/assets/spth.png')
                
                              }, null, 8, _hoisted_56),
                              _hoisted_57,
                              _createElementVNode("div", _hoisted_58, _toDisplayString(li.remark), 1),
                              _hoisted_59,
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    class: "remark-pic",
                                    src: item.url,
                                    key: index
                                  }, null, 8, _hoisted_60))
                                }), 128))
                              ]),
                              _hoisted_61,
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.checkFileList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    class: "remark-pic",
                                    src: item.url,
                                    key: index
                                  }, null, 8, _hoisted_62))
                                }), 128))
                              ])
                            ])
                          ], 64))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"])
          ]))
        : _createCommentVNode("", true),
      (
        (_ctx.queryPloyLoad.checkType == 3 && _ctx.queryPloyLoad.status == 1) ||
        (_ctx.queryPloyLoad.checkType == 0 && _ctx.infodata.flag == 1)
      )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.remark,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.remark) = $event)),
                    rows: "2",
                    autosize: "",
                    type: "textarea",
                    placeholder: "请输入备注"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.uploader,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_70,
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.checkUploader,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkUploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", {
                class: "submit-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handle && _ctx.handle(...args)))
              }, "处理完成")
            ])
          ], 64))
        : _createCommentVNode("", true),
      (
        (_ctx.queryPloyLoad.checkType == 2 && _ctx.queryPloyLoad.status == 2) ||
        (_ctx.queryPloyLoad.checkType == 0 && _ctx.infodata.flag == 2)
      )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _hoisted_76,
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_van_field, {
                    modelValue: _ctx.remark,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.remark) = $event)),
                    rows: "2",
                    autosize: "",
                    type: "textarea",
                    placeholder: "请输入备注"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _hoisted_78,
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.uploader,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.uploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_81,
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_van_field, { name: "uploader" }, {
                    input: _withCtx(() => [
                      _createVNode(_component_van_uploader, {
                        modelValue: _ctx.checkUploader,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkUploader) = $event)),
                        "after-read": _ctx.afterRead,
                        multiple: _ctx.$isIOS()
                      }, null, 8, ["modelValue", "after-read", "multiple"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", {
                class: "noadoptbtn nopass",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fExamine(2)))
              }, "不通过"),
              _createElementVNode("div", {
                class: "adoptbtn",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fExamine(1)))
              }, "通过")
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      "z-index": "2000",
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"width":"100%"}
          }, null, 8, _hoisted_86)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}